<template>
  <div class="index-box">
    <div v-if="leaderList != ''">
      <div v-for="(item, index) in leaderList" :key="index">
        <!-- <div class="leaderBox">{{ item.position }}:{{ item.name }}</div> -->
        <div class="leaderBox">
          <span>{{ item.position }}</span>
          <div></div>
          <!-- <div> -->
          <div>{{ item.name }}</div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <div class="noDonationDiv">
        <img
          src="../../assets/image/btn_nojuanzeng_nor.png"
          alt="图片"
          class="noDonation"
        />
      </div>
      <div class="tip">暂时无领导数据~</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leaderList: [],
    };
  },
  created() {
    this.getLeader();
  },
  methods: {
    async getLeader() {
      const result = await this.$http.get("schoolProfiles/getLeaderNow");
      console.log("获取现任领导", result.data);
      this.leaderList = result.data;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .leaderBox {
    position: relative;
    display: flex;
    flex-direction: row;
    // justify-content: center;
    // align-items: center;
    width: 95vw;
    height: 70px;
    border: 1px solid #edeeed;
    border-radius: 5px;
    background: #fff;
    border-top: 2px solid #fff;
    border-left: 2px solid #fff;
    border-right: 3px solid #eed2b8;
    border-bottom: 3px solid #eed2b8;
    margin-top: 15px;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    color: #000;
  }
  .leaderBox :nth-child(1) {
    color: #000;
    font-weight: 400;
    width: 63%;
    // background: #eed2b8;
    margin-left: 0px;
    text-align: center;
    margin-top: 25px;
  }

  .leaderBox :nth-child(2) {
    width: 2px;
    height: 30px;
    margin: 20px 10px 0 10px;
    line-height: 5rem;
    background: #e2ece9;
    margin-right: 15px;
  }

  .leaderBox :nth-child(3) {
    color: #017371;
    width: 20%;
    // height: 4.7rem;
    // line-height: 5.1rem;
    // margin-left: 10px;
    // background: #b89b9b;
    text-align: justify;
    margin-top: 25px;
  }

  .leaderBox :nth-child(3):after {
    content: " ";
    display: inline-block;
    width: 100%;
  }

  .noDonationDiv {
    position: absolute;
    left: 50%;
    top: 10%;
    transform: translateX(-50%);
  }

  .noDonation {
    width: 100%;
  }

  .tip {
    position: absolute;
    left: 50%;
    top: 35%;
    transform: translateX(-50%);
    color: #666666;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/CurrentLeader.vue